export const HOME_PAGE = 'home-page';
export const LOBBY_PAGE = 'lobby-page';
export const SLOTS_PAGE = 'slots-page';
export const BLACKJACK_PAGE = 'blackjack-page';
export const ROULETTE_PAGE = 'roulette-page';
export const JACKPOTS_PAGE = 'jackpots-page';
export const CASINO_GAMES_PAGE = 'casino-games-page';
export const CASINO_GAMES_ALL_GAMES_PAGE = 'casino-games-page-all-games';
export const PROGRESSIVE_VIDEO_SLOTS_PAGE = 'progressive-video-slots-page';
export const GAMING_HISTORY_PAGE = 'gaming-history-page';
export const SESSION_HISTORY_PAGE = 'session-history-page';
export const CHALLENGE_PAGE = 'challenge-page';
export const LIVE_CASINO_PAGE = 'live-casino-page';
export const ARENA_LOBBY_PAGE = 'arena-lobby-page';
export const VIDEO_POKER_PAGE = 'video-poker-page';
export const SCRATCH_CARDS_PAGE = 'scratch-cards-page';
export const EXCLUSIVE_888_GAMES_PAGE = '888-exclusive-games';
export const NEW_LIVE_CASINO_PAGE = 'live-casino-new-page';
export const INSTANT_WIN_GAMES_PAGE = 'instant-win-games-page';
export const VIRTUAL_SPORTS_PAGE = 'virtual-sports-page';

export const LOBBY_GRID = 'lobby-grid';
export const WIDE_GRID = 'wide-grid';
export const ALIGN_TOP = 'align-top';
export const ORBIT_TAP = 'orbit-tap';
export const GAME_CATEGORY_CARD_AND_TABLES = 'game-category-card-and-table';
export const GAME_CATEGORY_LIVE = 'game-category-live';
export const GAME_COMPANY_NETENT = 'game-company-netent';
export const CGP_GAME_OPEN = 'cgp-game-open';
export const JACKPOTS_ITEM = 'jackpots-item';

export const MOVE_TOP = 'move-top';
export const STICKY = 'sticky';
export const ORBIT_OVERLAY_OPEN = 'orbit-overlay-open';
export const EMBEDDED_HYBRID  = 'cgp-embedded-hybrid';
export const MODAL_DIALOG = 'modal-dialog';
export const MAIN_SCREEN = 'main-screen';
export const MINI_ORBIT  = 'mini-orbit';

export const ACTIVE = 'active';
export const HIDE = 'hide';
export const SHOW = 'show';